import script from "./DrawerNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawerNotification.vue?vue&type=script&setup=true&lang=ts"

import "./DrawerNotification.vue?vue&type=style&index=0&id=3a4a3f76&scoped=true&lang=css"
import "./DrawerNotification.vue?vue&type=style&index=1&id=3a4a3f76&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4a3f76"]])

export default __exports__